import ArrowDown from "./ArrowDown.svg";
import Close from "./Close.svg";
import ExclaimCircle from "./ExclaimCircle.svg";
import InfoCircle from "./InfoCircle.svg";
import InfoCircleOutlined from "./InfoCircleOutlined.svg";
import InfoCircleOutlinedGray from "./InfoCircleOutlinedGray.svg";
import Cancel from "./Cancel.svg";
import Warning from "./Warning.svg";
import Download from "./Download.svg";
import QuestionMarkCircle from "./QuestionMarkCircle.svg";
import QuestionMarkCircleGray from "./QuestionMarkCircleGray.svg";
import SecureDark from "./SecureDark.svg";
import SecureWhite from "./SecureWhite.svg";
import ArrowRight from "./ArrowRight.svg";
import Checkmark from "./Checkmark.svg";
import SearchIcon from "./SearchIcon.svg";
import RoundedWarning from "./RoundedWarning.svg";
import Filter from "./Filter.svg";
import Plus from "./Plus.svg";
import Minus from "./Minus.svg";
import PurchasedIcon from "./vue/PurchasedIcon.vue";

const icons = {
  ArrowDown,
  Close,
  ExclaimCircle,
  InfoCircle,
  InfoCircleOutlined,
  InfoCircleOutlinedGray,
  Cancel,
  Warning,
  Download,
  QuestionMarkCircle,
  QuestionMarkCircleGray,
  SecureDark,
  SecureWhite,
  ArrowRight,
  Checkmark,
  SearchIcon,
  RoundedWarning,
  Filter,
  Plus,
  Minus,
};

export const iconsVue = {
  PurchasedIcon,
};
export default icons;
